import * as Yup from "yup";

export const mediaPerPost = Yup.number()
  .positive("No. of media(s) must be greater than 0")
  .required("No. of media(s) is required");
export const mediaSize = Yup.number()
  .positive("Maximum size must be greater than 0")
  .required("Maximum size of media is required");

export const appVersion = Yup.string().required("App version is required");
export const supportEmail = Yup.string().required("Support email is required");
export const currency = Yup.string()
  .required("Currency is required")
  .length(3, "Invalid currency");
export const currencySymbol = Yup.string()
  .required("Currency symbol is required")
  .matches(/^[^\w\s]{1}$/, "Please enter a valid currency symbol")
  .length(1, "Invalid currency symbol");
export const appName = Yup.string().required("App name is required");

export const paginationSize = Yup.number()
  .positive("Pagination size must be greater than 0")
  .typeError("Pagination size must be a number")
  .integer("Only integer values are accepted")
  .required("Pagination size is required");

export const NearbyProfessionalLimit = Yup.number()
  .positive("Limit must be greater than 0")
  .required("Limit is required");
export const listLimit = Yup.number()
  .typeError("Limit must be a number")
  .required("Limit is required")
  .positive("Limit must be greater than 0")
  .integer("Limit must be a whole number");
export const clockInRadius = Yup.number()
  .positive("Radius must be greater than 0")
  .required("Radius is required");

export const suggestionPageSize = Yup.number()
  .positive("Suggestion page size must be greater than 0")
  .required("Suggestion page Size is required");

export const mileageRadius = Yup.number()
  .positive("Radius must be greater than 0")
  .required("Radius is required");

export const imageSize = Yup.number()
  .positive("Image size must be greater than 0")
  .required("Image size is required");

export const Burden = Yup.number()
  .min(0, "Burden must be greater than or equal to 0")
  .max(100, "Burden must be less than or equal to 100")
  .required("Burden is required");
